import { useState, useEffect } from "react";

// Breakpoint definitions (in pixels)
export const BREAKPOINTS = {
  mobile: 480,
  tablet: 768,
  desktop: 1280,
};

export const useResponsiveLayout = (previewMode) => {
  const [activeLayout, setActiveLayout] = useState(previewMode || "desktop");
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1280
  );

  // Determine layout based on window width
  const getLayoutFromWidth = (width) => {
    if (width <= BREAKPOINTS.mobile) return "mobile";
    if (width <= BREAKPOINTS.tablet) return "tablet";
    return "desktop";
  };

  // Set up window resize listener and layout determination
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setWindowWidth(width);

      // Only auto-determine layout if not in preview mode
      if (!previewMode) {
        setActiveLayout(getLayoutFromWidth(width));
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Initial check

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [previewMode]);

  // When previewMode changes from parent, update activeLayout
  useEffect(() => {
    if (previewMode) {
      setActiveLayout(previewMode);
    } else {
      setActiveLayout(getLayoutFromWidth(windowWidth));
    }
  }, [previewMode, windowWidth]);

  return {
    activeLayout,
    windowWidth,
  };
};
